import React, { Component } from "react"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"
import shop from "shop/shop"
import { parse } from "babyparse"
import _ from "lodash"

import "./CSV.scss"

export default class CSV extends Component {

  static propTypes = {
    onError      : PropTypes.func,
    onResult     : PropTypes.func,
    getProducts  : PropTypes.func,
    skipFirstLine: PropTypes.bool,
    onText       : PropTypes.func
  }

  state = { files: [] }

  handleText = ( result ) => {
    const { onText, skipFirstLine } = this.props

    let options = {
      delimiter: ";",
    }


    let res = parse( result )
    console.log("CHECK: ",parse( result ))
    for(var i = 0;i < res.data.length;i++){
      console.log("CHECK: ",res.data[i][0])
      if(res.data[i][0].includes("/")){
       res.data[i][0] = res.data[i][0].replace("/","_")
      }
    }
    if ( res.errors && res.errors.length > 0 ) {
      console.warn( "Errors", res.errors )
      if ( this.props.onError ) this.props.onError( res )
    }
    let positions = res.data.map( pos => {
      return { id: pos[ 0 ], count: pos[ 1 ] }
    } )

    if ( skipFirstLine ) {
      positions = positions.slice( 1 )
    }

    positions = positions.filter( pos => pos.id !== "" )

    if ( onText ) {
      if ( onText ) onText( { positions } )
    }

    let ids = positions.map( pos => pos.id )

    shop.products.list( ids )
      .then( products => {
        _.each( products, product => {
          let count = _.find( positions, { id: product.map_id } )
          product.count = count.count || 0
        } )
        return products
      } )
      .then( this.onResult )
  }

  onResult = ( products ) => {
    if ( this.props.onResult ) this.props.onResult( { products } )
  }

  onDrop( files ) {
    const file = files[ 0 ]
    if ( !file ) return
    var reader = new FileReader()
    reader.addEventListener( "loadend", ( event ) => {
      this.handleText( event.target.result )
    } )
    reader.readAsText( file )
    this.setState( { files } )
  }

  render() {
    return (
      <section className="Csv">
        <div className="dropzone">
          <Dropzone accept=".csv" style={{}} multiple={false} onDrop={this.onDrop.bind( this )}>
            <p>{translate("Datei hier platzieren")}</p>
          </Dropzone>
        </div>
        <aside>
          <ul>
            {this.state.files.map( ( f, key ) => <li key={key}>{f.name} - {f.size} bytes</li> )}
          </ul>
        </aside>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/theme/braunsheitmann/components/CSV/CSV.js